export type SubscriptionUpdateDTO = Pick<SubscriptionDTO, 'id' |'created' | 'start' | 'end' | 'capacity' | 'quadernoId'>

export interface SubscriptionDTO {
  id: string,
  subscriptionType: "yearly" | "monthly" | "trial" | "free" | "one_dollar" | "one_euro",
  created: number,
  start: number,
  end: number,
  capacity: number,
  invoiceId: string,
  quadernoId: number,
  primaryContact: string
}

export interface Subscription {
  id: string,
  subscriptionType: "yearly" | "monthly" | "trial" | "free" | "one_dollar" | "one_euro",
  created: Date,
  start: Date,
  end: Date,
  capacity: number,
  quadernoId: number,
  primaryContact: string,
  unitPrice?: number,
  currency?: string,
  customerId?: string
}

export function subscriptionDTOToSubscription(subscriptionDTO: SubscriptionDTO): Subscription {
  return {
    ...subscriptionDTO,
    created: new Date(subscriptionDTO.created),
    start: new Date(subscriptionDTO.start),
    end: new Date(subscriptionDTO.end)
  }
}

export function subscriptionToSubscriptionUpdateDTO(subscription: Subscription): SubscriptionUpdateDTO {
  return {
    id: subscription.id,
    created: subscription.created.getTime(),
    start: subscription.start.getTime(),
    end: subscription.end.getTime(),
    capacity: subscription.capacity,
    quadernoId: subscription.quadernoId,
  }
}